import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Credits_Log } from '@polylearn/models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DialogComponent } from './dialog.component';
import { AlertOptions, BaseData, ConfirmOptions, CustomOptions, DialogData, PromptOptions } from './dialog.interface';

@Injectable({
  providedIn: 'root'
})
export class DialogService {

  constructor(
    public dialog: MatDialog,
  ) { }


  private openDialog(dialogData: DialogData) {
    const dialogRef = this.dialog.open(DialogComponent, {
      width: '700px',
      data: dialogData,
      ...dialogData.matDialogConfig
    });

    return dialogRef.afterClosed().pipe(
      map(res => res)
    );
  }

  public prompt(baseData: BaseData, options: PromptOptions): Observable<string> {
    const data: DialogData = {
      ...baseData,
      type: 'prompt',
      options
    };

    return this.openDialog(data);
  }


  public alert(baseData: BaseData, options: AlertOptions): Observable<string> {
    const data: DialogData = {
      ...baseData,
      type: 'alert',
      options
    };

    return this.openDialog(data);
  }


  public confirm(baseData: BaseData, options: ConfirmOptions): Observable<boolean> {
    const data: DialogData = {
      ...baseData,
      type: 'confirm',
      options
    };

    return this.openDialog(data);
  }

  public custom(baseData: BaseData, options: CustomOptions): Observable<any> {
    const data: DialogData = {
      ...baseData,
      type: 'custom',
      options,
      matDialogConfig: {
        width: '1200px',
      }
    };

    return this.openDialog(data);
  }

}
